import { useMemo } from 'react';

import { MedicalDeviceFistulaType } from '@dreryk/egabinet-ezwm-frontend-api';

import { RadioGroup, RadioGroupItem } from '@dreryk/react-components';

import { medicalDevicesTranslationKeys } from '../../translations';
import {
   MedicalDeviceOrderFistulaTypeFormBeanPart,
   MedicalDeviceOrderFormRegister,
   MedicalDeviceOrderFormWatch,
} from '../medicalDeviceOrder.types';
import { isMedicalDeviceFieldRequired } from '../medicalDeviceOrder.utils';

type FistulaTypeFieldProps = {
   readonly register: MedicalDeviceOrderFormRegister<MedicalDeviceOrderFistulaTypeFormBeanPart>;
   readonly watch: MedicalDeviceOrderFormWatch<MedicalDeviceFistulaType>;
};

const radioGroupItems: RadioGroupItem<MedicalDeviceFistulaType>[] = [
   {
      id: 'UROSTOMY',
      label: medicalDevicesTranslationKeys.fields.fistulaType.UROSTOMY,
   },
   {
      id: 'COLOSTOMY',
      label: medicalDevicesTranslationKeys.fields.fistulaType.COLOSTOMY,
   },
   {
      id: 'ILEOSTOMY',
      label: medicalDevicesTranslationKeys.fields.fistulaType.ILEOSTOMY,
   },
   {
      id: 'OTHER',
      label: medicalDevicesTranslationKeys.fields.fistulaType.OTHER,
   },
];

export const FistulaTypeField = (props: FistulaTypeFieldProps): JSX.Element => {
   const required = isMedicalDeviceFieldRequired(props.watch, 'fistulaType');
   const validationRules = useMemo(() => {
      if (required) {
         return {
            required: {
               value: required,
               message: medicalDevicesTranslationKeys.fields.fistulaTypeRequired,
            },
         };
      }
      return undefined;
   }, [required]);
   return (
      <RadioGroup
         testId={'fistulaType'}
         label={medicalDevicesTranslationKeys.fields.fistulaType.fistulaType}
         controller={props.register('fistulaType', validationRules)}
         items={radioGroupItems}
         horizontal
      />
   );
};
